export default __webpack_public_path__ + "6bc9bd05196d9022e104525d2fcee070.svg";